// api
import ModelService from '@/services/model.service'
import { mapState } from 'vuex'

export default {
  name: 'Work',
  data() {
    return {
      // 英语 中文 越南语 柬埔寨语 印尼语
      adIdList: [10, 22, 48, 66, 83],
      swiperId: [15, 23, 52, 70, 87],
      pageIdList: '',
      pageIdList_pc: [24, 26, 104, 113, 119],
      pageIdList_mp: [249, 247, 251, 253, 255],
      // data
      swiperSlides: '',
      pageInfo: '',
      bannerInfo: '',
      swiperOption: {
        freeMode: true,
        slidesPerView: 'auto',
        centeredSlides: true,
        mousewheel: true,
        loop : true,
        autoplay : {
          delay: 3000,
          disableOnInteraction: false,
        },
      },
    };
  },
  computed: mapState({
    ...mapState(['isPC', 'language', 'LangIndex'])
  }),
  watch: {
    LangIndex: {
      handler(str) {
        this.init();
      },
    },
  },
  mounted() {
    this.switchAdlist();
  },
  methods: {
    init() {
      this.getBannerList();
      this.getAdPictureList();
      this.getPageInfo();
    },
    // 根据客户端切换广告位id
    switchAdlist() {
      if (this.isPC) {
        this.pageIdList = this.pageIdList_pc;
      } else {
        this.pageIdList = this.pageIdList_mp;
      }
      this.init();
    },
    // 根据id获取页面内容
    getPageInfo() {
      const param = {
        id: this.pageIdList[this.LangIndex],
      };
      ModelService.getPageInfo(param).then((res) => {
        if (res.code === 0) {
          this.pageInfo = res.data;
        }
      });
    },
    // 根据id获取广告图片
    getBannerList() {
      const param = {
        lang: this.language,
        adId: this.adIdList[this.LangIndex],
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0) {
          this.bannerInfo = res.data[0];
        }
      });
    },
    // 根据id获取广告图片
    getAdPictureList() {
      const param = {
        lang: this.language,
        adId: this.swiperId[this.LangIndex],
      };
      ModelService.getbanner(param).then((res) => {
        if (res.code === 0) {
          this.swiperSlides = res.data;
        }
      });
    },
  },
};
